
// Component boilerplate
import React from 'react';

const RiPanelAiStatistics = ({
    title,
    color,
    data,
    count,
    currentChange,
    currentDuration,
    periodicityText
}) => {
  const median = ((data.median || 0)*100).toFixed(1);
  const pct90Th = ((data.pct90th || 0)*100).toFixed(1)
  const medianChange = (median- currentChange).toFixed(1);
  const pct90Change = (pct90Th - currentChange).toFixed(1);
  const disabled = currentChange > 0 && median > 0 || currentChange < 0 && median < 0
  return (
    <table className={`stats-table ${disabled ? "": "disable"}`}>
          <thead>
            <tr>
              <th className={`${color}`}>{title}</th>
              <th colSpan="2" className="head-data ri-action-bg">% CHANGE</th>
              <th colSpan="2" className="head-data ri-action-bg">DURATION</th>
            </tr>
            <tr>
              <th className={`count-label ${color}`}>Ct: {count}</th>
              <th className="positive">TARGET</th>
              <th className="positive">REMAINING</th>
              <th className="positive">TARGET</th>
              <th className="positive">REMAINING</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="positive">MEDIAN</td>
              <td className="cell-data">{median}%</td>
              <td className="cell-data">{currentChange > 0 && median > 0 || currentChange < 0 && median < 0 ? medianChange + "%" : "-"}</td>
              <td className="cell-data">{data.medianDuration}{periodicityText}</td>
              <td className="cell-data">{currentChange > 0 && median > 0 || currentChange < 0 && median < 0 ? (data.medianDuration - currentDuration) + periodicityText : "-"}</td>
            </tr>
            <tr>
              <td className="positive">90th %</td>
              <td className="cell-data">{pct90Th}%</td>
              <td className="cell-data">{currentChange > 0 && pct90Th > 0 || currentChange < 0 && pct90Th < 0 ? pct90Change + "%" : "-"}</td>
              <td className="cell-data">{data.pct90Duration}{periodicityText}</td>
              <td className="cell-data">{currentChange > 0 && pct90Th > 0 || currentChange < 0 && pct90Th < 0 ? (data.pct90Duration - currentDuration) + periodicityText : "-"}</td>
            </tr>
          </tbody>
        </table>
  );
};
export default RiPanelAiStatistics;
